import { ConfigServiceProvider } from '../config-service/config-service';
import { ENVIRONMENT } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Layout } from './layout.interface';
import { StorageServiceProvider } from '../storage-service/storage-service';
import { TextServiceProvider } from '../text-service/text-service';
import { View } from '../../pages/tabs/interfaces/view.interface';
import { MapOfStringTo } from '../../../ranking/interfaces/utils';

@Injectable()
export class LayoutServiceProvider {
  private readonly layoutUrl = '../../../../assets/layout.json';
  private layoutType = 'default';
  private layout: Layout = null;

  constructor(
    private http: HttpClient,
    private storageService: StorageServiceProvider,
    public configService: ConfigServiceProvider,
    public textService: TextServiceProvider,
  ) {}

  public load() {
    return new Promise<void>((resolve, reject) => {
      this.http
        .get(this.getSource())
        .toPromise()
        .then(
          (layout: any) => {
            this.layout = ENVIRONMENT.useLocalConfigs ? layout[this.layoutType] : layout;
            return this.storageService.setObject('layout', this.layout);
          },
          (error) => reject(error),
        )
        .then(
          () => resolve(),
          (error) => reject(error),
        );
    });
  }

  private getSource(): string {
    if (ENVIRONMENT.useLocalConfigs) return this.layoutUrl;
    return this.configService.getEngineUrl('layout');
  }

  private setIcon(view: View) {
    const iconName = this.textService.get('icon' + view.title);
    view.icon = iconName ? iconName : view.icon;
  }

  public setTitle(view: View) {
    const title = this.textService.get('menu' + view.title);
    view.title = title ? title : view.title;
  }

  private prepareMenuToDisplay() {
    this.layout.layout.forEach((item) => {
      this.translateView(item);
      if (item.type === 'TABS') {
        item.content.tabs.forEach((view: View) => this.translateView(view));
      }
    });
  }

  private translateView(view: View) {
    this.setIcon(view);
    this.setTitle(view);
  }

  public setLayoutType(type: string) {
    if (type) this.layoutType = type;
    else this.layoutType = 'default';
    this.prepareMenuToDisplay();
  }

  public getViewFromPages(id: string): View {
    return this.layout.page[id];
  }

  public getLayout(): Layout {
    return this.layout;
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/services/layout-service/layout-service.ts